module.exports = __webpack_public_path__ + "img/64-green.89dbb9ce.svg";